import type { headingFonts } from './consts';
import { parseLanguageFromLocale } from './parseLanguageFromLocale';

export type HeadingFontFamily = (typeof headingFonts)[keyof typeof headingFonts];

export function resolveHeadingFontByLocale(locale: string): HeadingFontFamily {
  const language = parseLanguageFromLocale(locale);

  if (language === 'ja') {
    return 'WoltHeading-M-Plus-Rounded-1c';
  }

  if (['kk', 'ka', 'el', 'he'].includes(language)) {
    return 'WoltHeading-October';
  }

  return 'WoltHeading-Omnes';
}
